import { CheckIcon, MinusIcon } from '@radix-ui/react-icons';
import { Button, Spinner } from '@radix-ui/themes';
import Analytics from 'ui/design-base/Analytics';
import { follow, unfollow } from 'store/followUnfollow/followUnfollowSlice';
import { useAppDispatch, useAppSelector } from 'store/store';

export const FollowUnfollowButton: React.FC<{ followed: boolean; id: number; type: string }> = ({
  followed,
  id,
  type,
}) => {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.followUnfollow);

  return followed ? (
    <Button
      variant='outline'
      className='min-w-28 hover:cursor-pointer'
      onClick={() => {
        dispatch(unfollow({ id: id!, type: type! }));
        Analytics.sendEvent({ category: 'Profile Interaction', action: 'Unfollow Button', label: 'Player Header' });
      }}
    >
      {loading ? <Spinner /> : <MinusIcon />}
      Segui già
    </Button>
  ) : (
    <Button
      variant='outline'
      className='min-w-24 hover:cursor-pointer'
      onClick={() => {
        dispatch(follow({ id: id, type: type }));
        Analytics.sendEvent({ category: 'Profile Interaction', action: 'Follow Button', label: 'Player Header' });
      }}
    >
      {loading ? <Spinner /> : <CheckIcon />}
      Segui
    </Button>
  );
};

export default FollowUnfollowButton;
